export enum DocumentName {
    INFO_Invoice = "Invoice_Document",
    INFO_COMPANY_REQUEST_LETTER = "Company_Request_Letter",
    COO_PROD_TEMP_ENG = "/files/COO_UPLOAD_PRODUCTS_TEMPLATE_ENGLISH.xlsx",
    COO_PROD_TEMP_AR = "/files/COO_UPLOAD_PRODUCTS_TEMPLATE_ARABIC.xlsx",
    ATA_PROD_TEMP_ENG = "/files/ATA_UPLOAD_PRODUCTS_TEMPLATE_ENGLISH.xlsx",
    ATA_PROD_TEMP_ARA = "/files/ATA_UPLOAD_PRODUCTS_TEMPLATE_ARABIC.xlsx",
    COO_USED_PERSONAL_EFFECTS_BOUGHT_FROM = 'https://dcdigitalservices.dubaichamber.com/siebel/used_personal_effects_bought_from_local_market.pdf',
    COO_USED_VEHICLE_BOUGHT_FROM = 'https://dcdigitalservices.dubaichamber.com/siebel/used_vehicle_bought_from_the_local_market.pdf',
    COO_ANIMAL_EXPORT_FORM = 'https://dcdigitalservices.dubaichamber.com/siebel/Animal_Export_Form.pdf',
    SIGNATURE_CARD = 'https://dcdigitalservices.dubaichamber.com/siebel/Signature_Card.pdf',
    PERSONAL_COO_RTA = "Export certificate from RTA",
    BGC_MEMBER_TEMP_ENG = "/files/Board_Committee_Template.xlsx",
    BGC_MEMBER_TEMP_ARA = "/files/Board_Committee_Template.xlsx",
    BGC_LIST_MEMBERS ="List of Members",
    BGC_SUPPORTING_DOCUMENTS="Additional Supporting Documents"
}